
export const convertColHeaderConfigToRowData = ({colHeaderData, convertToRichText}) => {
  return {
    id: "colHeader",
    isColHeader: true,
    cellData: colHeaderData.map((d, i) => ({
      value: convertToRichText ? convertToRichText(d) : d, //draftjs data shape
      readOnly: true,
      id: `colHeaderCell_${i}`,
    })),
  };
};